/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_LoadingInputs */

const en_practice_loading = /** @type {(inputs: Practice_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading library…`)
};

const es_practice_loading = /** @type {(inputs: Practice_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando biblioteca…`)
};

const de_practice_loading = /** @type {(inputs: Practice_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bibliothek wird geladen…`)
};

const zh_practice_loading = /** @type {(inputs: Practice_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在加载库…`)
};

const ar_practice_loading = /** @type {(inputs: Practice_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ تحميل المكتبة…`)
};

const fr_practice_loading = /** @type {(inputs: Practice_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement de la bibliothèque…`)
};

const vi_practice_loading = /** @type {(inputs: Practice_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tải thư viện…`)
};

const sw_practice_loading = /** @type {(inputs: Practice_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inapakia maktaba…`)
};

const th_practice_loading = /** @type {(inputs: Practice_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังโหลดไลบรารี…`)
};

const bs_practice_loading = /** @type {(inputs: Practice_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Učitavanje biblioteke…`)
};

const ja_practice_loading = /** @type {(inputs: Practice_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ライブラリの読み込み…`)
};

const ko_practice_loading = /** @type {(inputs: Practice_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로딩…`)
};

const pt_practice_loading = /** @type {(inputs: Practice_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando a biblioteca…`)
};

const it_practice_loading = /** @type {(inputs: Practice_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento della libreria…`)
};

const sv_practice_loading = /** @type {(inputs: Practice_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laddar biblioteket…`)
};

const nl_practice_loading = /** @type {(inputs: Practice_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bibliotheek wordt geladen…`)
};

const da_practice_loading = /** @type {(inputs: Practice_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indlæser bibliotek…`)
};

const nb_practice_loading = /** @type {(inputs: Practice_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laster bibliotek…`)
};

const fi_practice_loading = /** @type {(inputs: Practice_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ladataan kirjastoa`)
};

const pl_practice_loading = /** @type {(inputs: Practice_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wczytywanie biblioteki…`)
};

const ru_practice_loading = /** @type {(inputs: Practice_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка библиотеки…`)
};

const tr_practice_loading = /** @type {(inputs: Practice_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kütüphane yükleniyor…`)
};

const hi_practice_loading = /** @type {(inputs: Practice_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पुस्तकालय`)
};

const id_practice_loading = /** @type {(inputs: Practice_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat pustaka…`)
};

const ms_practice_loading = /** @type {(inputs: Practice_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuatkan pustaka…`)
};

const cs_practice_loading = /** @type {(inputs: Practice_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nahrávám knihovnu…`)
};

const el_practice_loading = /** @type {(inputs: Practice_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Φόρτωση βιβλιοθήκης…`)
};

const he_practice_loading = /** @type {(inputs: Practice_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`טוען ספרייה…`)
};

const af_practice_loading = /** @type {(inputs: Practice_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laai tans biblioteek…`)
};

const hu_practice_loading = /** @type {(inputs: Practice_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Könyvtár betöltése…`)
};

/**
* | output |
* | --- |
* | "Loading library…" |
*
* @param {Practice_LoadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const practice_loading = /** @type {((inputs?: Practice_LoadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_LoadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_practice_loading(inputs)
	if (locale === "de") return de_practice_loading(inputs)
	if (locale === "zh") return zh_practice_loading(inputs)
	if (locale === "ar") return ar_practice_loading(inputs)
	if (locale === "fr") return fr_practice_loading(inputs)
	if (locale === "vi") return vi_practice_loading(inputs)
	if (locale === "sw") return sw_practice_loading(inputs)
	if (locale === "th") return th_practice_loading(inputs)
	if (locale === "bs") return bs_practice_loading(inputs)
	if (locale === "ja") return ja_practice_loading(inputs)
	if (locale === "ko") return ko_practice_loading(inputs)
	if (locale === "pt") return pt_practice_loading(inputs)
	if (locale === "it") return it_practice_loading(inputs)
	if (locale === "sv") return sv_practice_loading(inputs)
	if (locale === "nl") return nl_practice_loading(inputs)
	if (locale === "da") return da_practice_loading(inputs)
	if (locale === "nb") return nb_practice_loading(inputs)
	if (locale === "fi") return fi_practice_loading(inputs)
	if (locale === "pl") return pl_practice_loading(inputs)
	if (locale === "ru") return ru_practice_loading(inputs)
	if (locale === "tr") return tr_practice_loading(inputs)
	if (locale === "hi") return hi_practice_loading(inputs)
	if (locale === "id") return id_practice_loading(inputs)
	if (locale === "ms") return ms_practice_loading(inputs)
	if (locale === "cs") return cs_practice_loading(inputs)
	if (locale === "el") return el_practice_loading(inputs)
	if (locale === "he") return he_practice_loading(inputs)
	if (locale === "af") return af_practice_loading(inputs)
	if (locale === "hu") return hu_practice_loading(inputs)
	return en_practice_loading(inputs)
});